module.exports = __webpack_public_path__ + "5b4c4f931fd8372bee83e9b06157c71b.MP3";